import { render, staticRenderFns } from "./BlastListDetails.vue?vue&type=template&id=aa22972c&scoped=true"
import script from "./BlastListDetails.vue?vue&type=script&lang=js"
export * from "./BlastListDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa22972c",
  null
  
)

export default component.exports